/* eslint-disable */
/**
 * Auto generated version file, do not modify it!
 */
const version = '1.31.4';
export { version };
//# sourceMappingURL=version.js.map